import Cta from "../shared/Cta";

export default function ResumeCta() {
  return (
    <Cta
      id="resume-cta"
      title="Don't See the Right Role?"
      description="We're always looking for talented people who care about EV charging and sustainable mobility. Email us your resume and we'll reach out when a fit opens up."
      buttonLabel="Email Us Your Resume"
      buttonHref="mailto:career@slscorp.com?subject=Resume%20Submission%20-%20General%20Interest"
      variant="brand"
    />
  );
}
